import { GetterTree } from 'vuex'
import { LessonStateInterface } from 'src/store/lesson/state'
import { StoreInterface } from 'src/store'
import {
  ItemUser,
  StreamRoleEnum
  , ItemSetting
} from 'able-lib'

const getters: GetterTree<LessonStateInterface, StoreInterface> = {
  getLessonStudents: ({ lessonDraft }: LessonStateInterface): Array<ItemUser> => {
    const students = Array.from(lessonDraft.itemUsers.filter(itemUser => itemUser.role.name === StreamRoleEnum.ATTENDEE))
    students.forEach((student, index) => {
      let isSpliced = false
      student.user.userRoles.forEach((role) => {
        if (role.role.id !== 9 && role.role.id !== 3 && !isSpliced) {
          students.splice(index, 1)
          isSpliced = true
        }
      })
    })
    return students
    // return lessonDraft.itemUsers.filter(itemUser => itemUser.role.name === StreamRoleEnum.ATTENDEE)
  },

  getSettings: ({ lessonDraft }: LessonStateInterface): Array<ItemSetting> => {
    return lessonDraft.itemSettings
  }
}

export default getters
